var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-input"},[_c('input',{ref:"fileInput",attrs:{"type":"file","accept":"application/pdf"},on:{"change":function($event){return _vm.onSelectFile()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }